<template>
    <div>
        <div class="clearfix mb-2" v-if="true">

            <h5 class="float-left">Available Staff ({{ filteredAvailableStaff.length }})</h5>
            <div class="float-right">
                <b-form-checkbox-group v-model="filterIncludeRoles"
                                       :options="filterRoleOptions"></b-form-checkbox-group>
                <b-form-checkbox v-model="filterNoAssignedJobsOnly">Only show staff with no Jobs assigned</b-form-checkbox>
            </div>
            <div class="float-right mr-4">
                <b-form-input size="sm" v-model="nameFilter" placeholder="Name filter"></b-form-input>
            </div>
        </div>

        <div>
            <b-list-group-item class="m-2" v-if="(filteredAvailableStaff == null) || (filteredAvailableStaff.length == 0)">
                No available Staff found for this day.
            </b-list-group-item>
        </div>

        <b-table id="availableStaffTable" class="text-center align-middle table-bordered w-100" small hover responsive sort-icon-left bordered :current-page="currentPage" :per-page="perPage" :fields="fields" :items="filteredAvailableStaff" v-if="(filteredAvailableStaff != null) && (filteredAvailableStaff.length > 0)">

            <template v-slot:cell(roles)="{ item }">
                <template v-for="role in item.roles">
                    <img class="mr-2" :src="getRoleImageUrl(role.roleId)" :alt="role.roleDisplayName" :title="role.roleDisplayName" width="30" :key="role.roleId" v-if="isRoleRelevant(role.roleId)" />
                </template>
            </template>

            <template v-slot:head(skillLevel)="">
                Skill
                <br />Level
            </template>
            <template v-slot:cell(skillLevel)="{ item }">
                <template v-if="item.skillLevel">
                    {{ item.skillLevelDisplayName }}
                </template>
            </template>

            <template v-slot:cell(employmentTypeDisplayName)="{ item }">
                <template v-if="item.employmentTypeDisplayName">
                    {{ item.employmentTypeDisplayName }}
                </template>
            </template>

            <template v-slot:head(securityClearance)="">
                Security
                <br />Clearance
            </template>
            <template v-slot:cell(securityClearance)="{ item }">
                <template v-if="item.securityClearance">
                    {{ item.securityClearanceDisplayName }}
                </template>
            </template>

            <!--
            <template v-slot:cell(pm)="{ item }">
                <i class="text-success fas fa-check" key="pmcheck" v-if="item.pm"></i>
            </template> -->

            <template v-slot:head(audioMinutes)="">
                Delayed
                <br />(minutes)
            </template>

            <template v-slot:cell(options)="{ item }">
                <span class="mr-1 p-1 border border-dark rounded" v-if="item.availableForTravel">TVL</span>
                <span class="mr-1 p-1 border border-dark rounded" v-if="item.availableForOnSite">O/S</span>
                <span class="mr-1 p-1 border border-dark rounded" v-if="item.availableForRealTime">RT</span>
            </template>

            <template v-slot:cell(comments)="{ item }">
                <b-badge v-b-popover.hover.focus="item.comments" v-if="item.comments">view</b-badge>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <b-form-checkbox :checked="staffSelected(item)" @change="staffSelectChanged(item)" />
            </template>
        </b-table>

        <div class="float-left mr-3">
            <div v-for="role in relevantRoles" :key="role.roleId">
                <img :src="getRoleImageUrl(role.roleId)" :alt="role.roleDisplayName" width="20" class="mr-1" />{{ role.roleDisplayName }}
            </div>
        </div>

        <div class="float-left mr-4">
            TVL: Available for Travel<br>
            O/S: Available for On Site<br>
            RT:  Available for Real Time
        </div>

        <div class="float-right">
            <b-pagination v-model="currentPage"
                          :total-rows="filteredAvailableStaff.length"
                          :per-page="perPage"
                          size="sm"
                          align="right"
                          aria-controls="availableStaffTable"
                          v-if="(filteredAvailableStaff != null) && (filteredAvailableStaff.length > 0)">
            </b-pagination>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue'
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UserMixin from '../../mixins/UserMixin';

    Vue.use(BootstrapVue);

    export default {

        name: 'AvailabilityStaffList',
        mixins: [DateTimeMixin, UserMixin],
        model: {
            event: 'change',
            prop: 'selectedStaff'
        },
        props: {
            imagesUrl: {
                type: String,
                required: true
            },
            availableStaff: {
                type: Array,
                default: null
            },
            selectedStaff: {
                type: Array,
                default: null
            },
            relevantRoles: {
                type: Array,
                required: true
            },
            showFilter: {
                type: Boolean,
                default: false
            },
            allowSelection: {
                type: Boolean,
                default: false
            }
        },
        data: function () {

            return {
                fields: [],
                currentPage: 1,
                perPage: 10,
                nameFilter: '',

                currentSelectedStaff: this.selectedStaff,
                filterIncludeRoles: Array.from(this.relevantRoles, role => role.roleId), //this will "convert" the array of objects into an array of role IDs
                filterNoAssignedJobsOnly: false
            }
        },
        watch: {
            selectedStaff: function () {
                this.currentSelectedStaff = this.selectedStaff;
            }
        },
        computed: {
            filterRoleOptions: function () {
                var roles = [];
                this.relevantRoles.forEach((role) => {
                    roles.push({ value: role.roleId, text: role.roleDisplayName });
                });
                return roles;
            },

            filteredAvailableStaff: function () {
                var filteredStaffList = [];

                if (this.availableStaff && this.availableStaff.length) {
                    // to make sure that THIS referes to the component inside the forEach
                    var thisComponent = this;
                     
                    this.availableStaff.forEach(function (staffMember) {

                        if ((thisComponent.currentSelectedStaff != null) && (thisComponent.currentSelectedStaff.indexOf(staffMember.userAccountId) >= 0)) {
                            filteredStaffList.push(staffMember);
                        } else {
                            var include = false;
                            var assignedRoles = staffMember.roles;
                            for (var i = 0; i < assignedRoles.length; i++) {
                                var roleId = assignedRoles[i].roleId;
                                if (thisComponent.filterIncludeRoles && (thisComponent.filterIncludeRoles.indexOf(roleId) >= 0)) include = true;
                            }
                            if (include && thisComponent.filterNoAssignedJobsOnly) {
                                if (staffMember.assignedJobs > 0) include = false;
                            }

                            var nameInclude = true;
                            if (thisComponent.nameFilter != '') {
                                if (staffMember.givenNames.toLowerCase().indexOf(thisComponent.nameFilter.toLowerCase()) < 0 &&
                                    staffMember.lastName.toLowerCase().indexOf(thisComponent.nameFilter.toLowerCase()) < 0) { nameInclude = false; }
                            }

                            if (include && nameInclude) { filteredStaffList.push(staffMember); }
                        }
                    });
                }

                return filteredStaffList;
            }
        },
        methods: {
            assignedJobsTdClass: function (value) {
                if (value == 0) return 'align-middle bg-success';
                return 'align-middle';
            },
            isRoleRelevant(roleId) {
                return this.relevantRoles.find(role => role.roleId == roleId);
            },
            staffSelected: function (user) {
                return ((this.currentSelectedStaff != null) && (this.currentSelectedStaff.indexOf(user.userAccountId) >= 0));
            },
            staffSelectChanged: function (user) {
                if (this.currentSelectedStaff == null) {
                    this.currentSelectedStaff = [];
                    this.currentSelectedStaff.push(user.userAccountId);
                } else {
                    var i = this.currentSelectedStaff.indexOf(user.userAccountId);
                    if (i < 0) {
                        this.currentSelectedStaff.push(user.userAccountId);
                    } else {
                        this.currentSelectedStaff.splice(i, 1);
                    }
                }
                this.$emit('change', this.currentSelectedStaff);
            }
        },
        created: function () {
            this.fields = [
                { key: 'givenNames', label: 'First Name', sortable: true, tdClass: 'text-left align-middle' },
                { key: 'lastName', label: 'Last Name', sortable: true, tdClass: 'text-left align-middle' },
                { key: 'roles', label: 'Roles', tdClass: 'align-middle' },
                {
                    key: 'assignedJobs', label: 'Jobs', tdClass: (value) => {
                        return (value == 0) ? 'align-middle bg-success' : 'align-middle';
                    }
                },
                { key: 'skillLevel', label: 'Skill Level', sortable: true, tdClass: 'align-middle' },
                { key: 'employmentTypeDisplayName', label: 'Employment Type', sortable: true, tdClass: 'align-middle' },
                { key: 'securityClearance', label: 'Security Clearance', sortable: true, tdClass: 'align-middle' },
                { key: 'sameDayMinutes', label: 'Same Day', tdClass: 'align-middle' },
                
                { key: 'audioMinutes', label: 'Delayed (minutes)', sortable: true, tdClass: 'align-middle' },
                { key: 'options', label: 'Options', tdClass: 'align-middle' },
                { key: 'comments', label: 'Comments', tdClass: 'align-middle' },
            ]
            if (this.allowSelection) {
                this.fields.push({ key: 'actions', label: '', tdClass: 'align-middle' });
            }
        }
    }
</script>

<style scoped>

    .table thead th {
        vertical-align: middle !important;
    }
</style>